import http from "../http/http-config";
import { TheftQuotationResponse } from "../models/theftQuotationResponse";

export default new class TheftQuotationService {
    //Movilidad Urbana 
    createTheft936Quotation(model: string): Promise<TheftQuotationResponse> {        
        return http.post<TheftQuotationResponse>("TheftQuotation", model).then(response => response.data);
    }

    //Equipo Electronico
    createTheft1000Quotation(model: string): Promise<TheftQuotationResponse> {
        return http.post<TheftQuotationResponse>("TheftQuotation/GetTheft1000Quotation", model).then(response => response.data);
    }

}